"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: fixed;\n    top: -3000;\n    left: -3000;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents["default"].div(_templateObject());

var ContentMetaResolver = function ContentMetaResolver(props) {
  var Content = props.component,
      onResolved = props.onResolved,
      children = props.children;
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _ref$current$getClien = ref.current.getClientRects()[0],
        height = _ref$current$getClien.height,
        width = _ref$current$getClien.width;
    onResolved({
      height: height,
      width: width
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var content = children || _react["default"].createElement(Content, null);

  return (0, _reactDom.createPortal)(_react["default"].createElement(Container, {
    ref: ref
  }, content), document.body);
};

var _default = ContentMetaResolver;
exports["default"] = _default;